import PropTypes              from 'prop-types';
import React                  from 'react';
import Flux                   from '../../flux/Flux';
import {getCommonTranslation} from '../../utils/TranslationHelper';
import {
	postCommentType,
	REPLY_SIGN
}                             from "./FeedHelper";
import {VXPay}                from '../../utils/VXPay';

let inputDefaultHeight = 0;

class FeedPostInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			comment:         '',
			selectedComment: null,
		};

		this.areaRef = null;

		this.onInputChange  = this.onInputChange.bind(this);
		this.onClickSend    = this.onClickSend.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(this.props.selectedComment) !== JSON.stringify(prevProps.selectedComment) || JSON.stringify(this.props.selectedCommentToggle) !== JSON.stringify(prevProps.selectedCommentToggle)) {
			this.props.hasAvs && this.props.selectedComment && this.setState({
				comment:         this.getUserName(),
				selectedComment: this.props.selectedComment
			});
		}
	}

	getUserName() {
		return REPLY_SIGN + this.props.selectedComment.user.name + '  ';
	}

	handleKeyPress(e) {
		if (!this.props.hasAvs) {
			return;
		}

		if (e.keyCode === 13 && !e.shiftKey) {
			this.onClickSend();
		}
	}

	onInputChange(e) {
		if (!this.props.hasAvs) {
			return;
		}
		const text = e.target.value;

		if (this.props.selectedComment && (this.areaRef.selectionStart < this.getUserName().length && this.state.selectedComment)) {
			if (this.state.selectedComment && text.length < this.getUserName().length) {
				this.setState({comment: '', selectedComment: null});
			}
			this.areaRef.selectionStart = this.getUserName().length;
			return;
		}

		if (this.state.selectedComment && text.length < this.getUserName().length) {
			this.setState({comment: '', selectedComment: null});
		} else {
			this.setState({comment: text});
		}
		if (!inputDefaultHeight) {
			inputDefaultHeight = this.areaRef.style.height;
		}

		this.areaRef.style.height = inputDefaultHeight;
		this.areaRef.style.height = this.areaRef.scrollHeight + 'px';
	}

	onClickSend(e) {
		if (!this.canSend()) {
			return;
		}
		if (e) {
			e.preventDefault();
		}

		let comment           = this.state.comment;
		let selectedCommentId = null;

		if (this.state.selectedComment) {
			if (this.state.selectedComment.parentId) { //reply of reply
				comment = this.state.comment.replace('  ', ' ');
			} else {
				comment = this.state.comment.replace(this.getUserName(), ''); // reply of main comment
			}
		}

		if (this.state.selectedComment) {
			selectedCommentId = this.state.selectedComment.id;
		}

		Flux.Feed.commentPost(this.props.id, comment, selectedCommentId, (response) => {
			this.areaRef.style.height = inputDefaultHeight;
			this.setState({comment: '', selectedComment: null});
			if (response.error) {
				console.log(response.error.message);
				//this.setState({comment: response.error.message, selectedComment: null});
			} else {
				Flux.Feed.triggerUpdatePost(this.props.id);
				this.areaRef.style.height = inputDefaultHeight;
				this.setState({comment: '', selectedComment: null});
			}
		});
	}

	canSend() {
		if (!this.props.hasAvs) {
			return false;
		}
		if (this.state.selectedComment) {
			return this.state.comment.length > (this.getUserName().length);
		}
		if (Flux.Guest.isBlockedForComments()) {
			return false;
		}
		return this.state.comment.length > 0;
	}

	commentsDisabled() {
		return !this.props.hasAvs || Flux.Guest.isBlockedForComments();
	}

	onClickCommentAddSection(e) {
		if (!Flux.Guest.hasAvs()) {
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			VXPay.openAVS();
		}
	}

	onFocus() {
		const mobileNav = document.querySelector('.vxnavbar__wrapper');
		if (mobileNav) {
			mobileNav.style.display = "none";
		}
	}

	onBlur() {
		const mobileNav = document.querySelector('.vxnavbar__wrapper');
		if (mobileNav) {
			mobileNav.style.display = "block";
		}
	}

	render() {
		return (
			<div className="feed-comment-add" onClick={this.onClickCommentAddSection}>
				<div className="feed-comments-image-container">
					<div className="feed-comments-image-wrapper">
						<img className="feed-comments-image" src={Flux.Guest.getGuestUrlPreviewPicture()}></img>
					</div>
				</div>
				<div className="feed-comment-add__input-wrapper">
					{this.props.hasAvs && this.state.selectedComment &&
						<div className="feed-comment-add__input-placeholder">{this.getUserName()}</div>}
					<textarea
						disabled={this.commentsDisabled()}
						ref={(ref) => this.areaRef = ref}
						onKeyUp={this.handleKeyPress}
						onChange={this.onInputChange}
						value={this.state.comment}
						type="text"
						placeholder={Flux.Guest.isBlockedForComments() ? getCommonTranslation('blocked-for-comments') : getCommonTranslation('comment-on') + '...'}
						className="feed-comment-add__input"
						onFocus={this.onFocus}
						onBlur={this.onBlur}
					></textarea>
				</div>
				{!this.commentsDisabled() && <i
                        onClick={this.onClickSend} tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && this.onClickSend(e)}
				   className={'icon -icon-send-chat-full feed-comment-add__icon' + (this.canSend() ? ' feed-comment-add__icon--active' : '')}
				/>}
			</div>
		);
	}
}

FeedPostInput.propTypes = {
	id:                    PropTypes.string.isRequired,
	hasAvs:                PropTypes.bool,
	selectedCommentToggle: PropTypes.bool,
	selectedComment:       PropTypes.shape(postCommentType),
};

FeedPostInput.defaultProps = {
	selectedComment:       null,
	selectedCommentToggle: false,
	hasAvs:                false,
};

export default FeedPostInput;
